import { TFunction } from "i18next";

export type NewsCopyField =
  | "title"
  | "content"
  | "detailContent"
  | "dateDisplay"
  | "seoTitle"
  | "seoDescription"
  | "coverImageAlt";

export type ZodiacCopyField =
  | "name"
  | "dateRange"
  | "rulingPlanet"
  | "description"
  | "luckyColor";

export type ZodiacListField =
  | "traits"
  | "strengths"
  | "weaknesses"
  | "compatibleWith";

const translatedString = (
  t: TFunction,
  key: string,
  defaultValue = "",
): string => {
  const value = t(key, { defaultValue });
  return typeof value === "string" ? value : defaultValue;
};

export const getNewsCopy = (
  t: TFunction,
  newsId: string,
  field: NewsCopyField,
  defaultValue = "",
) => translatedString(t, `news.items.${newsId}.${field}`, defaultValue);

export const getNewsPartnerCopy = (
  t: TFunction,
  newsId: string,
  partnerId: string,
  field: "name" | "description",
  defaultValue = "",
) =>
  translatedString(
    t,
    `news.items.${newsId}.partners.${partnerId}.${field}`,
    defaultValue,
  );

export const getZodiacCopy = (
  t: TFunction,
  signId: string,
  field: ZodiacCopyField,
  defaultValue = "",
) => translatedString(t, `zodiac.signs.${signId}.${field}`, defaultValue);

export const getZodiacList = (
  t: TFunction,
  signId: string,
  field: ZodiacListField,
): string[] => {
  const value = t(`zodiac.signs.${signId}.${field}`, { returnObjects: true });
  return Array.isArray(value)
    ? value.filter((item): item is string => typeof item === "string")
    : [];
};
